import * as React from 'react';
import * as _ from 'lodash';
import { styled } from '../../theme';
import { BetaPillWidget } from '../BetaPillWidget';

export const LargeButtonIconWidget: React.FC<{
  selected: boolean;
  onSelect: () => any;
  label: string;
  image: string | JSX.Element;
  beta?: boolean;
}> = (props) => {
  return (
    <S.Integration
      selected={props.selected}
      onClick={() => {
        props.onSelect();
      }}
    >
      {_.isString(props.image) ? <S.IntegrationIcon src={props.image} /> : props.image}
      <S.IntegrationLabel>{props.label}</S.IntegrationLabel>
      {props.beta ? <S.BetaPill active={props.selected} /> : null}
    </S.Integration>
  );
};

namespace S {
  const ICON_SIZE = 70;

  export const Integration = styled.div<{ selected: boolean }>`
    cursor: pointer;
    padding: 20px;
    border-radius: 10px;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 5px;
    margin-right: 5px;
    background: ${(p) => (p.selected ? p.theme.sidebar.backgroundActive : 'rgba(0, 0, 0, 0.4)')};
  `;

  export const IntegrationLabel = styled.div`
    margin-top: 10px;
    color: white;
    width: 150px;
    text-align: center;
  `;

  export const IntegrationIcon = styled.div<{ src: string }>`
    width: ${ICON_SIZE}px;
    height: ${ICON_SIZE}px;
    background-image: url('${(p) => p.src}');
    background-position: center center;
    background-repeat: no-repeat;
    background-size: contain;
  `;

  export const BetaPill = styled(BetaPillWidget)`
    margin-top: 5px;
  `;
}
